import { useState, useEffect } from 'react'

import { useFilterData } from 'app/common/ui-components/filter'
import { flags as details } from 'app/components/common/reports/filters/details'

import { flags as account } from '../ReportFilter/filters/account'
import { flags as group } from '../ReportFilter/filters/group'
import { flags as groupComplexesSpecial } from '../ReportFilter/filters/groupComplexesSpecial'

/**
 *  Управление отображением данных
 */

export type DisplaySettings = {
  showAccountNumber: boolean
  showPhone: boolean
  byGroupComplexes: boolean
  byCampComplexes: boolean
  byProductType: boolean
  details: boolean
  byPaymentMethodForMultipleSchools: boolean
  byItemsAndComplexesAndCostForMultipleSchools: boolean
}

const defaultState: DisplaySettings = {
  showAccountNumber: false,
  showPhone: false,
  byGroupComplexes: false,
  byCampComplexes: false,
  byProductType: false,
  details: false,
  byPaymentMethodForMultipleSchools: false,
  byItemsAndComplexesAndCostForMultipleSchools: false,
}

export default function useDisplaySettings(ready: boolean): DisplaySettings {
  const [, , , { getApplied }] = useFilterData()
  // так и должно быть, через state, не оптимизировать, иначе будет неверный результат
  const [settings, setSettings] = useState(defaultState)

  useEffect(() => {
    if (ready) {
      const applied = getApplied()

      if (applied) {
        setSettings({
          showAccountNumber: account.accountNumberApplied(applied),
          showPhone: account.phoneApplied(applied),
          byGroupComplexes:
            group.byGroupComplexesApplied(applied) ||
            groupComplexesSpecial.byGroupComplexesSpecialApplied(applied),
          byCampComplexes:
            group.byCampComplexesApplied(applied) ||
            groupComplexesSpecial.byCampComplexesSpecialApplied(applied),
          byProductType: group.byProductTypeApplied(applied),
          details: details.detailsApplied(applied),
          byPaymentMethodForMultipleSchools: groupComplexesSpecial.byPaymentMethodApplied(applied),
          byItemsAndComplexesAndCostForMultipleSchools:
            groupComplexesSpecial.byItemsAndComplexesAndCostApplied(applied),
        })
      }
    }
  }, [ready]) // eslint-disable-line react-hooks/exhaustive-deps

  return settings
}
